import styled from 'styled-components';

export const WhatOurGuestLikeLoader = styled.div(
  props => ` 
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin-right:${props.theme.spacing.base} ;
    width:29rem;
    background-color:${props.theme.colors.goWhite.base};
    border-radius:${props.theme.misc.borderRadius.large};
    padding: 0 0 ${props.theme.spacing.base} 0;
    border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
  
  `,
);

export const WhatOurGuestLikeInnerLoader = styled.div(
  props => `
    margin-top:${props.theme.spacing.xlarge};   
    `,
);

export const WhatOurGuestLikeSmallWrap = styled.div(
  props => `
    display:flex;
    width:15.5rem;
    height:1.6rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: ${props.theme.spacing.base} ${props.theme.spacing.base} 0 ${props.theme.spacing.base} ; 
  `,
);

export const WhatOurGuestLikeMediumWrap = styled.div(
  props => `
    display:flex;
    width:18.4rem;
    height:1.6rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: ${props.theme.spacing.base} ${props.theme.spacing.base} 0 ${props.theme.spacing.base} ;    
    `,
);

export const WhatOurGuestLikeLargeWrap = styled.div(
  props => `
    display:flex;
    width:22.4rem;
    height:1.6rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-color:${props.theme.colors.goBrandBlue.medium};
    margin: ${props.theme.spacing.base} ${props.theme.spacing.base} 0 ${props.theme.spacing.base} ; 
    `,
);
